import { defineMessages, type IntlShape } from 'react-intl'

import { PRODUCT_SEARCH_FACET } from '../config/PRODUCT_SEARCH_FACET'

const labels = defineMessages<PRODUCT_SEARCH_FACET>({
  [PRODUCT_SEARCH_FACET.ABSORBENCY]: {
    id: 'general.label.absorbency',
  },
  [PRODUCT_SEARCH_FACET.ACTIVE_SUBSTANCES]: {
    id: 'general.label.filter.substances',
  },
  [PRODUCT_SEARCH_FACET.ANIMAL_SPECIES]: {
    id: 'general.label.animalSpecies',
  },
  [PRODUCT_SEARCH_FACET.APPLICATION_AREAS]: {
    id: 'general.label.filter.applicationAreas',
  },
  [PRODUCT_SEARCH_FACET.AUTHORS]: {
    id: 'general.label.author',
  },
  [PRODUCT_SEARCH_FACET.AVERAGE_RATING]: {
    id: 'ratingOverview.headline',
  },
  [PRODUCT_SEARCH_FACET.BOOK_LANGUAGE]: {
    id: 'general.label.language',
  },
  [PRODUCT_SEARCH_FACET.BRAND_SEARCH]: {
    id: 'general.label.brand',
  },
  [PRODUCT_SEARCH_FACET.CERTIFICATES]: {
    id: 'general.label.filter.certificates',
  },
  [PRODUCT_SEARCH_FACET.DISCOUNT_IN_PERCENT]: {
    id: 'general.label.filter.discount',
  },
  [PRODUCT_SEARCH_FACET.DIVISIBILITY]: {
    id: 'general.label.filter.divisibility',
  },
  [PRODUCT_SEARCH_FACET.FILTER_ATTRIBUTES]: {
    id: 'general.label.filter.attributes',
  },
  [PRODUCT_SEARCH_FACET.HAIR_COLOR]: {
    id: 'general.label.hairColor',
  },
  [PRODUCT_SEARCH_FACET.HAIR_LENGTH]: {
    id: 'general.label.hairLength',
  },
  [PRODUCT_SEARCH_FACET.HAIR_TYPE_MULTI]: {
    id: 'general.label.hairtype',
  },
  [PRODUCT_SEARCH_FACET.HAIRCUT]: {
    id: 'general.label.haircut',
  },
  [PRODUCT_SEARCH_FACET.HEAD_CIRCUMFERENCE]: {
    id: 'general.label.headCircumference',
  },
  [PRODUCT_SEARCH_FACET.LENS_TYPES]: {
    id: 'general.label.lens_types',
  },
  [PRODUCT_SEARCH_FACET.LIFE_STAGE]: {
    id: 'general.label.lifeStage',
  },
  [PRODUCT_SEARCH_FACET.MANUFACTURER]: {
    id: 'general.label.manufacturer',
  },
  [PRODUCT_SEARCH_FACET.MINERAL_AND_TRACE_ELEMENTS]: {
    id: 'general.label.filter.minerals',
  },
  [PRODUCT_SEARCH_FACET.NOW_PRODUCT_GROUP]: {
    id: 'general.label.shippingOptions',
  },
  [PRODUCT_SEARCH_FACET.PHARMA_FORM]: {
    id: 'general.label.filter.pharmaceuticalForm',
  },
  [PRODUCT_SEARCH_FACET.POTENCY]: {
    id: 'general.label.potency',
  },
  [PRODUCT_SEARCH_FACET.PRESCRIPTION_MEDICINE]: {
    id: 'prescription.labels.prescriptionType',
  },
  [PRODUCT_SEARCH_FACET.PRICE]: {
    id: 'general.label.sort.price',
  },
  [PRODUCT_SEARCH_FACET.PRIMARY_CATEGORY]: {
    id: 'general.label.categories',
  },
  [PRODUCT_SEARCH_FACET.PRODUCT_TYPE_FILTER]: {
    id: 'general.label.filter.productType',
  },
  [PRODUCT_SEARCH_FACET.PUBLISHER]: {
    id: 'general.label.publisher',
  },
  [PRODUCT_SEARCH_FACET.RECOMMENDED_AGE]: {
    id: 'general.label.age',
  },
  [PRODUCT_SEARCH_FACET.SCHUESSLER_SALTS]: {
    id: 'general.label.schuesslerSalts',
  },
  [PRODUCT_SEARCH_FACET.SKIN_TYPE_MULTI]: {
    id: 'general.label.skintype',
  },
  [PRODUCT_SEARCH_FACET.SPECIAL_NEEDS]: {
    id: 'general.label.specialNeeds',
  },
  [PRODUCT_SEARCH_FACET.SPORTS]: {
    id: 'general.label.filter.sport',
  },
  [PRODUCT_SEARCH_FACET.TEXTURE]: {
    id: 'general.label.filter.texture',
  },
  [PRODUCT_SEARCH_FACET.UV_PROTECTION]: {
    id: 'general.label.uv_protection',
  },
  [PRODUCT_SEARCH_FACET.VARIANTS_PACK_SIZE]: {
    id: 'general.label.quantity',
  },
  [PRODUCT_SEARCH_FACET.VARIETY]: {
    id: 'general.label.variety',
  },
  [PRODUCT_SEARCH_FACET.VITAMINS]: {
    id: 'general.label.filter.vitamins',
  },
  [PRODUCT_SEARCH_FACET.VOLTAGE]: {
    id: 'general.label.voltage',
  },
})

const facetAttributes = Object.values(PRODUCT_SEARCH_FACET)

export const productSearchGetRefinementLabel = (
  attribute: string,
  intl: IntlShape,
): string => {
  const facet = facetAttributes.find((item) => item === attribute)

  return facet ? intl.formatMessage(labels[facet]) : attribute
}
